import { baseApi } from "./baseApi";
import { TFaq } from "../../../types";

export const faqApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getFaq: builder.query<TFaq[], void>({
      query: () => ({ url: "/faq" }),
      transformResponse: (response: { data: TFaq[] }) => response.data ?? response,
      providesTags: ["Faq"],
    }),
  }),
});

export const { useGetFaqQuery } = faqApi;
